import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline, secondaryFill, secondaryOutline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M78.4314 43.88C78.4314 43.88 59.7514 33.63 55.7014 28.9C51.2014 23.64 51.4014 1 51.4014 1H38.9814C38.9814 1 39.2914 23.75 34.6814 28.9C29.7914 34.36 11.7314 43.22 11.7314 43.22C17.9214 57.8 35.6614 67.5 45.2014 67.5C54.7414 67.5 72.2414 58.46 78.4314 43.88Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M86.7312 58.22C84.8712 46.86 81.5212 43.74 76.8512 41.51L45.0712 59.36L13.2912 41.51C8.62123 43.74 4.99122 47.18 3.41122 58.22C1.78122 69.58 1.49121 71.29 1.49121 71.29H88.6412C88.6512 71.29 88.4012 68.43 86.7312 58.22Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M34.1513 19.6501L46.1913 28.6201L56.6413 20.9501C56.6413 20.9501 57.7113 20.6201 58.6013 22.7701C59.4913 24.9201 63.0713 35.6701 63.0713 35.6701L45.9513 32.3701L27.0713 36.5001C27.0713 36.5001 31.6513 22.7901 32.1913 21.3101C32.7313 19.8201 34.1513 19.6501 34.1513 19.6501Z"
        fill={secondaryFill}
        stroke={secondaryOutline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M46.6715 30.55C46.6715 30.55 38.8315 36.83 35.6315 41.61C31.8515 47.25 27.9715 54.99 34.0315 64.73C34.0315 64.73 35.1015 61.43 37.2415 58.12C40.1015 53.7 44.5815 49.74 45.4315 45.4C47.2015 36.33 46.6715 30.55 46.6715 30.55Z"
        fill={secondaryFill}
        stroke={secondaryOutline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M46.1911 28.6301C46.1911 28.6301 42.0311 40.1301 44.3511 48.5601C46.6711 56.9801 53.9711 65.5701 53.9711 65.5701C53.9711 65.5701 59.3111 52.0301 57.8911 45.4201C56.4611 38.8101 46.1911 28.6301 46.1911 28.6301Z"
        fill={secondaryFill}
        stroke={secondaryOutline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M46.1914 28.6301C47.5114 30.3201 48.5314 32.2301 49.3914 34.1801C50.2514 36.1401 50.9414 38.1801 51.4614 40.2601C51.9514 42.3501 52.3514 44.4601 52.4814 46.6001C52.6714 48.7301 52.6114 50.8801 52.3614 53.0001C51.9914 50.8901 51.7214 48.8101 51.3214 46.7501C50.9514 44.6901 50.5014 42.6401 50.0014 40.6201C49.5314 38.5901 48.9114 36.5901 48.2914 34.5901C47.6614 32.6001 46.9714 30.6201 46.1914 28.6301Z"
        fill={secondaryOutline}
      />
      <path
        d="M42.6309 25.54L49.7509 25.76L49.5208 33.25L43.1109 33.47L42.6309 25.54Z"
        fill={secondaryFill}
        stroke={secondaryOutline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path d="M42.6309 30.04L33.1309 29.29L42.6309 28.54V30.04Z" fill={secondaryOutline} />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="45.0765"
          y1="40.1871"
          x2="45.0765"
          y2="14.1906"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
